
<template>
  
  <v-app id="searchBtodDone">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
         
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td>{{props.item.btod_aan_type}} </td>
              <td>{{props.item.btod_aan_oms}} </td>
              <td>{{props.item.btod_ref_type}} </td>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.btod_ref_oms}} </a></td>
              <td align="right">{{props.item.btod_bedrag}} </td>
              <td>{{props.item.btod_batch_code}} </td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";

 export default {
  components: {
    navBar
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Type', value: 'btod_aan_type'},
        {text: 'Description', value: 'btod_aan_oms'},
        {text: 'Ref. Type', value: 'btod_ref_type'},
        {text: 'Ref. Description', value: 'btod_ref_oms'},
        {text: 'Amount', align: 'end', value: 'btod_bedrag'},
        {text: 'ARES Batch', value: 'btod_batch_code'}
      ]
    }

  },
  mounted() {
      this.results = true;
      /* console.log(this.$route.fullPath) */
      this.$axios
        .post("ares/json/ares/task/fin/abn/searchBtod.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchBtod"
          },
          searchBtod: {
            stat: 'done'
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.searchBtod;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  }
}

</script> 
